import ru from './legalTranslations/ru';
import uk from './legalTranslations/uk';
import pl from './legalTranslations/pl';
import de from './legalTranslations/de';
import fr from './legalTranslations/fr';
import it from './legalTranslations/it';
import es from './legalTranslations/es';
import pt from './legalTranslations/pt';
import nl from './legalTranslations/nl';
import sv from './legalTranslations/sv';
import da from './legalTranslations/da';
import nb from './legalTranslations/nb';
import fi from './legalTranslations/fi';
import et from './legalTranslations/et';
import lv from './legalTranslations/lv';
import lt from './legalTranslations/lt';
import hu from './legalTranslations/hu';
import el from './legalTranslations/el';
import ro from './legalTranslations/ro';
import hr from './legalTranslations/hr';
import sl from './legalTranslations/sl';
import bg from './legalTranslations/bg';
import sr from './legalTranslations/sr';
import bs from './legalTranslations/bs';
import cnr from './legalTranslations/cnr';
import mk from './legalTranslations/mk';
import tr from './legalTranslations/tr';

export default {ru, uk, pl, de, fr, it, es, pt, nl, sv, da, nb, fi, et, lv, lt, hu, el, ro, hr, sl, bg, sr, bs, cnr, mk, tr};
